export const SCREEN_LOCK_TIMEOUT =  1000 * 60 * 30;
export const DISABLE_USER_TIMEOUT = 1000 * 60 * 15;



// WEBPACK FOOTER //
// ./src/app/shared/constants.ts